import { get, post, put, del } from "../../helpers/utils/http-client";
import {
  ADMIN_ENDPOINT,
  clearImpersonation,
  getStoredImpersonation,
} from "../auth/impersonation-service";

// Support-staff only (members of the `bc-support` Cognito group); see admin/impersonation-api.

export async function searchAccounts(params) {
  try {
    return await get(`${ADMIN_ENDPOINT}/accounts/search`, params);
  } catch (err) {
    console.debug('searchAccounts failed cause', err.message, err.code);
    return { response: err.displayError, status: err.code };
  }
}

const accountLimitsUrl = accountId => `${ADMIN_ENDPOINT}/billing/accounts/${encodeURIComponent(accountId)}/limits`;

/** The account's custom conversation / AI usage limits, its plan's caps and this period's usage. */
export async function getAccountLimits(accountId) {
  try {
    return await get(accountLimitsUrl(accountId));
  } catch (err) {
    console.debug('getAccountLimits failed cause', err.message, err.code);
    return { response: err.displayError, status: err.code };
  }
}

/**
 * Sets the account's limits: `conversationsLimit` (per billing period) and `aiUsageLimitCents`. null removes a limit
 * so the plan's cap applies again; a field left out is kept. Answers like getAccountLimits.
 */
export async function updateAccountLimits(accountId, { conversationsLimit, aiUsageLimitCents }) {
  try {
    return await put(accountLimitsUrl(accountId), { conversationsLimit, aiUsageLimitCents });
  } catch (err) {
    console.debug('updateAccountLimits failed cause', err.message, err.code);
    return { response: err.displayError, status: err.code };
  }
}

export async function createImpersonationSession({ targetAccountId, reason, ticketRef }) {
  try {
    return await post(`${ADMIN_ENDPOINT}/impersonation`, { targetAccountId, reason, ticketRef });
  } catch (err) {
    console.debug('createImpersonationSession failed cause', err.message, err.code);
    return { response: err.displayError, status: err.code };
  }
}

/** Ends the session server-side (best effort), clears it locally and reloads into the support page. */
export async function endImpersonation() {
  const session = getStoredImpersonation();
  if (session) {
    try {
      await del(`${ADMIN_ENDPOINT}/impersonation/${encodeURIComponent(session.sessionId)}`);
    } catch (err) {
      console.debug('endImpersonation failed cause', err.message, err.code);
    }
  }
  clearImpersonation();
  window.location.assign('/support');
}
